@if(elementosVinculados && elementosVinculados.length > 0) {
    <table
        class="max-w-full bg-transparent mb-10"
        mat-table
        matSort
        [dataSource]="this.elementosVinculados"
        #elementos>

        <!-- Tipo -->
        <ng-container matColumnDef="tipo">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                Tipo
            </th>
            <td mat-cell *matCellDef="let elemento">
                <span class="whitespace-nowrap pr-6 text-sm">
                    {{ elemento.tipoEntidad.descripcion }}
                </span>
            </td>
        </ng-container>

        <!-- Nombre -->
        <ng-container matColumnDef="nombre">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                descripción
            </th>
            <td mat-cell *matCellDef="let elemento">
                <div class="min-w-90 pr-6 text-sm">
                    {{ elemento.descripcion}}
                </div>
            </td>
        </ng-container>

        <!-- Referencia -->
        <ng-container matColumnDef="referencia">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
                Referencia
            </th>
            <td mat-cell *matCellDef="let elemento">
                <span class="whitespace-nowrap pr-6 text-sm ">
                    {{ elemento.entidadPadreUuid}}
                </span>
            </td>
        </ng-container>

        <!-- Link -->
        <ng-container matColumnDef="link">
            <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-sm py-1">
            </th>
            <td mat-cell *matCellDef="let elemento">
                <button (click)="openTaskDetails(elemento)" class="whitespace-nowrap pr-6 text-sm ">
                    <mat-icon [svgIcon]="'heroicons_solid:arrow-top-right-on-square'" ></mat-icon>
                </button>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="actividesTableColumns" class="bg-gray-300"></tr>
        <tr class="order-row h-10" mat-row *matRowDef="let row; columns: actividesTableColumns;"></tr>
    </table>
}@else{
    <div class="flex items-center justify-center h-64">
        <p class="text-2xl font-medium text-gray-400">No hay elementos vinculados.</p>
    </div>
}
    

